import Headers from "@/component/Headers";
import UseResponsive from "@/utils/hooks/useResponsive";
import backgroundHeaderHistory from "@assets/web-v3-images/background-Header-History-top.png";
import { useState } from "react";
import { useTranslation } from 'react-i18next';
import ButtonTab from "./components/ButtonTab";
import LPhistory from "./components/LPhistory";
import Purchases from "./components/Purchases";
import Turn from "./components/Turn";
import Winners from "./components/Winners";
import { IS_UPDATE_VERSION_3_PROJECT } from '@/helper/const';
import { useLoginModal } from '@/contexts/LoginModalContext';
import { useSelector } from 'react-redux';
import { curStateAccount } from '@/Redux/selector';
import { hasAuthCookie } from '@/utils/auth';

export default function History() {
  const { t } = useTranslation();
  const { openLogin } = useLoginModal();
  const account = useSelector(curStateAccount);
  const isAuthed = hasAuthCookie() || Boolean(account?.userInfo) || Boolean(account?.token);

  const links = [
    { id: 1, name: t("history.winners"), value: "winners", path: "/winners" },
    { id: 2, name: t("history.turn"), value: "turn", path: "/turn" },
    { id: 3, name: t("history.purchases"), value: "purchases", path: "/purchases" },
    ...(IS_UPDATE_VERSION_3_PROJECT
      ? [
        { id: 4, name: t("history.LP_history"), value: "LP_history", path: "/lp-history" },
      ]
      : []),
  ];

  const [activeId, setActiveId] = useState(links[0].id);

  const handleTabClick = (link) => {
    // Nếu chọn tab index 3,5 mà chưa login -> show popup login, không đổi tab
    if ((link.id === 3 || link.id === 4) && !isAuthed) {
      openLogin();
      return;
    }
    setActiveId(link.id)
  };

  return (
    <UseResponsive autoHeight>
      <div
        className="history-page relative w-full flex-1 min-h-0 flex flex-col pb-10 bg-top bg-no-repeat bg-size-[100%_auto]"
        style={{
          backgroundImage: `url(${backgroundHeaderHistory})`,
        }}
      >

        {/* Content */}
        <div className="relative z-10 px-[20px] min-h-0 flex flex-col">
          <div className="pt-15">
            <Headers title={t('history.history')} />
          </div>

          <div
            className="
            flex gap-2 overflow-x-auto shrink-0
            pt-14
            pb-3
            px-4
            scrollbar-h-2
            scrollbar-thin
            scrollbar-thumb-[#E6B97D]
            scrollbar-track-transparent
          "
          >
            {links?.map((link) => (
              <ButtonTab
                key={link.id}
                text={link.name}
                active={activeId === link.id}
                onClick={() => handleTabClick(link)}
              />
            ))}
          </div>

          {/* Trang cao tối đa 100vh: nội dung dài hơn thì vùng tab co lại, table bên trong tự cuộn */}
          <div className="px-4 min-h-0 flex flex-col overflow-y-auto">
            {activeId === 1 && <Winners />}
            {activeId === 2 && <Turn />}
            {activeId === 3 && <Purchases />}
            {activeId === 4 && <LPhistory />}
          </div>
        </div>
      </div>
    </UseResponsive>
  );
}
